/**
 * Composition method for rd overview
 * 
 * Author: Sahil David
 */
import { computed } from 'vue';
import { getLyraEndpoints } from '@/core/modules/lyra/services';

export function rdDataComposition () {
	// Computed section data
	const datum = computed((): any[] => {
		const rdSections = getLyraEndpoints('rd-timeline');
		if (!rdSections) { return []; }

		return rdSections;
	});

	return { datum }
}
